import types from '../actionTypes';

const initialState = {
	isHidden: true,
	activeTest: null,
	sortDesc: true,
	testList: [],
	hasArchiveTests: null,
	isLoadingArchiveTests: false,
};

function testsReducer(state = initialState, action) {
	switch (action.type) {
		case types.GET_USER_TESTS:
			return {
				...state,
				testList: [...action.tests],
			};
		case types.SAVE_TEST:
			return {
				...state,
				testList: [...state.testList.filter((test) => test.id !== action.test.id), action.test],
				activeTest: null,
			};
		case types.DELETE_TEST:
			return {
				...state,
				testList: state.testList
					.filter((test) => test['id_testu'] !== action.testID)
					.filter((test) => test.id !== action.testID),
				activeTest: null,
			};
		case types.SET_ACTIVE_TEST:
			return {
				...state,
				activeTest: action.id,
			};
		case types.SORT_TESTS:
			return {
				...state,
				sortDesc: action.status,
			};
		case types.FADE_IN_MODULE:
			return {
				...state,
				isHidden: action.moduleName === 'test-list' ? false : state.isHidden,
			};
		case types.CHECK_ARCHIVE_TESTS:
			return {
				...state,
				hasArchiveTests: action.status,
			};
		case types.GET_ARCHIVE_TESTS:
			return {
				...state,
				isLoadingArchiveTests: action.isLoading,
			};
		default:
			return state;
	}
}

export default testsReducer;
